// Stub auth service — replace with real implementation
export const onAuthStateChange = (callback) => {
  // No user logged in by default
  callback(null);
  // Return unsubscribe function
  return () => {};
};

export const logoutAdmin = async () => {
  // Stub logout
};
